{
    "ExcludeheldtimeLabel": "Excluir tempo de espera:",
    "TalkTime_SectionHeader": "Hora de conversar",
    "TalkTime_SectionPara": "Você pode escolher se as estatísticas relacionadas ao tempo de conversação da chamada devem excluir o tempo de espera da chamada da lógica de cálculo.",
    "NAME": "TalkTime"
}